import script from "./WeOffer.vue?vue&type=script&setup=true&lang=js"
export * from "./WeOffer.vue?vue&type=script&setup=true&lang=js"

import "./WeOffer.vue?vue&type=style&index=0&id=66fb84d0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66fb84d0"]])

export default __exports__